"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var StarIcon = function StarIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.153 3.261c.684-1.642 3.01-1.642 3.694 0l1.751 4.212 4.547.364c1.773.142 2.492 2.355 1.141 3.513l-3.464 2.967 1.059 4.437c.412 1.73-1.47 3.098-2.988 2.17L12 18.548l-3.893 2.378c-1.518.927-3.4-.44-2.987-2.171l1.058-4.437-3.464-2.967c-1.351-1.158-.632-3.37 1.141-3.513l4.547-.364 1.751-4.212zm3.599 4.98L12 4.029l-1.752 4.212a2 2 0 0 1-1.686 1.225l-4.547.365 3.464 2.967a2 2 0 0 1 .644 1.983l-1.058 4.437 3.892-2.378a2 2 0 0 1 2.085 0l3.893 2.378-1.058-4.437a2 2 0 0 1 .644-1.983l3.464-2.967-4.546-.365a2 2 0 0 1-1.687-1.225z"
  }));
};
StarIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "rating": "rating_3BuQel",
  "star": "star_3nDexP",
  "selected": "selected_1n-Gtt"
}; 
require('./Rating.css');
var TOTAL_STARS = 5;
var Rating = function Rating(_ref) {
  var rating = _ref.rating,
    ariaHidden = _ref.ariaHidden,
    className = _ref.className,
    focusable = _ref.focusable;
  var truncatedRating = Math.floor(rating);
  return /*#__PURE__*/_react.default.createElement("div", {
    "aria-label": "".concat(truncatedRating, "/").concat(TOTAL_STARS, " Stars"),
    className: styles.rating,
    role: "img"
  }, Array.from({
    length: TOTAL_STARS
  }, function (_, index) {
    var selected = index < truncatedRating;
    return /*#__PURE__*/_react.default.createElement(StarIcon, {
      key: index,
      className: (0, _classnames.default)(styles.star, (0, _defineProperty2.default)({}, styles.selected, selected), className),
      "data-is-selected": selected,
      "aria-hidden": ariaHidden,
      focusable: focusable
    });
  }));
};
Rating.propTypes = {
  rating: _propTypes.default.number,
  className: _propTypes.default.string,
  ariaHidden: _propTypes.default.bool,
  focusable: _propTypes.default.bool
};
Rating.defaultProps = {
  rating: 0,
  className: '',
  ariaHidden: true,
  focusable: false
};
var _default = exports.default = Rating;
//# sourceMappingURL=Rating.js.map